module.exports = __webpack_public_path__ + "static/media/payment-logos.d27e659b.webp";